import { render } from "./AllBranches.vue?vue&type=template&id=3bb33f4c&scoped=true"
import script from "./AllBranches.vue?vue&type=script&lang=js"
export * from "./AllBranches.vue?vue&type=script&lang=js"

import "./AllBranches.vue?vue&type=style&index=0&id=3bb33f4c&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb33f4c"]])

export default __exports__